// apiMiddleware.js

import { handleLogoutRedux } from "../redux/authReducer";

const errorMiddleware = (store: any) => (next: any) => (action: any) => {
    if (action.payload && action.payload.status === 401) {
        store.dispatch(handleLogoutRedux());
        // Redirect to login page using React Router, if applicable
        // history.push('/login');
    }
    return next(action);
};

export default errorMiddleware;
